import React from 'react';
import { Image, Text, View } from 'react-native';
import { img_arrow_right } from '../../utils/ImagesManagementUtils';
import { textPrimary_11_6 } from '../SimulatorsComponents/AuxiliaryComponent/TextComponent/TextStyle';

//= ========================================================================

const BtnElement = ({
  globJSON,
  simPlatform,
  key,
  headline,
  isSquare,
  isBar,
}) => {
  const { colors } = globJSON.configurations.theme;
  const styles = {
    btnContainerBars: {
      borderRadius: isSquare ? 5 : 10,
      border: `solid 1px ${colors.border_color}`,
      boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.1)',
      paddingTop: 8,
      paddingBottom: 8,
      marginBottom: 10,
    },
    btnContainerCircle: {
      borderRadius: isSquare ? 5 : 10,
      border: `solid 1px ${colors.border_color}`,
      boxShadow: '0 0 4px 0 rgba(0, 0, 0, 0.1)',
      paddingTop: 8,
      paddingBottom: 8,
      marginBottom: 10,
    },
    image: {
      tintColor: colors.tertiary_icons_color,
      width: 14,
      height: 14,
      position: 'absolute',
      end: 2,
      top: 9,
    },
  };

  return (
    <View style={isBar ? styles.btnContainerBars : styles.btnContainerCircle} key={key}>
      <Text style={[textPrimary_11_6(globJSON, simPlatform), { textAlign: 'center' }]}>{headline}</Text>
      <Image
        fadeDuration={0}
        style={styles.image}
        source={img_arrow_right}
      />
    </View>
  );
};
export default BtnElement;
